import { render, staticRenderFns } from "./detail-luk.vue?vue&type=template&id=1913182a"
import script from "./detail-luk.vue?vue&type=script&lang=js"
export * from "./detail-luk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports